"use client";

import { useEffect } from "react";
import toast from "react-hot-toast";
import { setToStorage } from "@/helpers/storage";
import { STORAGE_KEYS } from "@/constants/storageKeys";
import { firebaseCloudMessaging } from "@/utils/firebase";

export default function FirebaseMessaging() {
  useEffect(() => {
    async function setToken() {
      try {
        const fcmToken = await firebaseCloudMessaging.init();
        if (fcmToken) {
          setToStorage(STORAGE_KEYS.fcmToken, fcmToken);
        }
      } catch (error) {
        console.error(error);
      }
    }

    setToken();

    // Event listener that listens for the push notification event in the background
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        try {
          event?.source?.postMessage("Hi client");
          console.log("event", event);

          const title = event?.data?.notification?.title ?? event?.data?.title ?? "Notification";
          const body = event?.data?.notification?.body ?? event?.data?.body ?? "";

          toast(
            (t) => (
              <div onClick={() => toast.dismiss(t.id)} style={{ cursor: "pointer" }}>
                <div style={{ fontWeight: 600, marginBottom: body ? "0.25rem" : 0 }}>{title}</div>
                {body ? <div style={{ fontSize: "0.813rem", color: "#666" }}>{body}</div> : null}
              </div>
            ),
            { duration: 5000 }
          );
        } catch (e) {
          console.error(e, "error");
        }
      });
    }

    if ("permissions" in navigator) {
      navigator.permissions
        .query({ name: "notifications" })
        .then(function (notificationPerm) {
          notificationPerm.onchange = function () {
            if (notificationPerm.state === "granted") {
              setToken();
              if (typeof window !== "undefined") {
                window.location.reload();
              }
            }
          };
        });
    }

    return () => {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.removeEventListener("message", (e) =>
          console.info(e)
        );
      }
    };
  }, []);

  return null;
}
